import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import {
  allDoctorDetail,
  appointementGet,
  appointementUpdate,
  patientSearchData,
} from '../../../redux/actions/Files.action';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  patientId: Yup.string().required('Patient is required'),
  dateOfAppointment: Yup.date()
    .required('Date of appointment is required')
    .nullable(),
  // bookingType: Yup.string().required('Booking type is required'),
  // subReference: Yup.string().required("Sub Reference is Required"),
  // notification: Yup.array()
  //   .of(Yup.string())
  //   .required('At least one notification method is required'),
});

const AppoinmentUpdate = ({
  updateModal,
  updateToggle,
  appointmentData,
  currentDate,
  limits
}) => {
  const dispatch = useDispatch();
  const leadData = useSelector((state) => state.files);
  const [formData, setFormData] = useState({
    patientId: '',
    dateOfAppointment: '',
    bookingType: '',
    subReference: '',
    notification: [],
    doctor: '',
    problem:''
  });
  const [doctorData1, setDoctorData1] = useState(false);
  const [problemData, setProblemData] = useState(false);
  const [selectedProblem, setSelectedProblem] = useState('');
  const [searchType, setSearchType] = useState('doctor');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDoctorId, setSelectedDoctorId] = useState('');
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
  });

  const initialValues = {
    patientId: formData.patientId,
    dateOfAppointment: formData.dateOfAppointment,
    remark: appointmentData?.remark || '',
    bookingType: formData.bookingType,
    subReference: formData.subReference,
    doctor: formData.doctor,
    problem:formData.problem,
    branch:formData.branch,
    branchAddress:formData.branchAddress,
    notification: formData.notification
  };
  const searchData = (e, setFieldValue) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    setFieldValue('patientId', '')
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
      // page: mainPage,
    };
    setSearchDefault(newSearchParams);
    dispatch(patientSearchData(newSearchQuery))
  }

  const selectProblem = (problemName) => {
    setSelectedProblem(problemName);
    setProblemData(false);
    setSearchQuery('');
    setSearchDefault({ page: '', search: '' });
    setFormData((prevValues) => ({
      ...prevValues,
      problem: problemName,
    }));
  };

  const handleBranchChange = (e, setFieldValue) => {
    const selectedBranch = e.target.value;
    setFieldValue('branch', selectedBranch);

    const branchDetails = leadData?.allBranch?.data?.Branches?.find(
      (b) => b.branchName === selectedBranch
    );

    setFieldValue('branchAddress', branchDetails?.branchLocation || '');
  };

  const handleAppointment = (values) => {
    const payload = {
      patientId: values.patientId,
      dateOfAppointment: values.dateOfAppointment,
      remark: values.remark,
      bookingType: values.bookingType,
      subReference: values.subReference,
      doctor: values.doctor,
      doctorId: selectedDoctorId,
      problem:values.problem,
      branch:values.branch,
      branchAddress:values.branchAddress,
      notification: values.notification
    };
    dispatch(
      appointementUpdate(appointmentData?._id, payload, currentDate, limits),
    ).then(() => {
      updateToggle();
      // setFormData({
      //   patientId: '',
      //   dateOfAppointment: '',
      //   bookingType: '',
      //   subReference: '',
      //   notification: []
      // })
      dispatch(appointementGet(currentDate));
    });
  };

  useEffect(() => {
    if (appointmentData) {
      setFormData({
        patientId: appointmentData.patientId || '',
        dateOfAppointment: appointmentData.dateOfAppointment || '',
        bookingType: appointmentData.bookingType || '',
        subReference: appointmentData.subReference || '',
        notification: appointmentData.notification || [],
        doctor: appointmentData.doctor || '',
        problem: appointmentData.issue || '',
        branch: appointmentData.branch || '',
        branchAddress: appointmentData.branchAddress || '',
      });
      if (appointmentData.doctor && leadData?.allDoctor?.data?.doctor) {
        const doctor = leadData?.allDoctor?.data?.doctor.find(
          (doc) => doc.name === appointmentData.doctor
        );
        if (doctor) {
          setSelectedDoctorId(doctor._id);
        } else {
          console.log('No matching doctor found for', appointmentData.doctor);
        }
      }
    }
    dispatch(allDoctorDetail())
  }, [appointmentData]);

  const handleData = (e) => {
    const { name, value, checked } = e.target;

    if (name === 'notification') {
      if (checked) {
        setFormData((prev) => ({
          ...prev,
          notification: [...prev.notification, value],
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          notification: prev.notification.filter((item) => item !== value),
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    const offset = date.getTimezoneOffset() * 60000; // Get timezone offset in milliseconds
    const localDate = new Date(date.getTime() - offset); // Adjust to local timezone
    return localDate.toISOString().slice(0, 16); // Get 'YYYY-MM-DDTHH:MM'
  };

  return (
    <Modal show={updateModal} onHide={updateToggle} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Update Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleAppointment}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-4">
                  <Form.Group className="mb-3" controlId="patient">
                    <Form.Label>Patient</Form.Label>
                    <Form.Control
                      type="text"
                      name="patient"
                      disabled
                      placeholder="Enter Patient"
                      className="shadow-none focus:!border-theme-dark"
                    />
                  </Form.Group>
                </div>

                <div className="col-md-4">
                  <Form.Group className="mb-3" controlId="firstName">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      value={appointmentData?.firstName}
                      disabled
                      placeholder="Enter First Name"
                      className="shadow-none focus:!border-theme-dark"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group className="mb-3" controlId="middleName">
                    <Form.Label>Middle Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="middleName"
                      value={appointmentData?.middleName}
                      disabled
                      placeholder="Enter Middle Name"
                      className="shadow-none focus:!border-theme-dark"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group className="mb-3" controlId="lastName">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      value={appointmentData?.lastName}
                      disabled
                      placeholder="Enter Last Name"
                      className="shadow-none focus:!border-theme-dark"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group className="mb-3" controlId="phoneNumber">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="nuber"
                      name="phoneNumber"
                      value={appointmentData?.phoneNumber}
                      disabled
                      placeholder="Enter Phone Number"
                      className="shadow-none focus:!border-theme-dark"
                    />
                  </Form.Group>
                </div>

                <div className="col-md-4">
                  <Form.Group className="mb-3" controlId="date">
                    <Form.Label> Date of appointment</Form.Label>
                    <Form.Control
                      type="datetime-local"
                      name="dateOfAppointment"
                      value={
                        formData?.dateOfAppointment
                          ? formatDate(formData.dateOfAppointment)
                          : ''
                      }
                      onChange={(e) => {
                        setFieldValue('dateOfAppointment', e.target.value);
                        handleData(e);
                      }}
                      className="shadow-none focus:!border-theme-dark"
                    />
                    <ErrorMessage
                      name="dateOfAppointment"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </div>

                <div className="col-md-4">
                  <Form.Group className="mb-3" controlId="problem">
                    <Form.Label>Consult </Form.Label>
                    <div className="relative">
                      <input
                        readOnly
                        placeholder="Select Consult"
                        className="border outline-none w-full border-theme-dark rounded py-[6px] px-[12px]"
                        name="problem"
                        onClick={() => {
                          setProblemData(!problemData);
                          setSearchType('problem')
                        }}
                        onChange={(e) =>
                          setFieldValue('problem', e.target.value)
                        }
                        value={values.problem}
                      />
                      {/* Default placeholder option */}
                      <div
                        className={`${problemData
                          ? 'opacity-100 visible'
                          : 'opacity-0 invisible'
                          } absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                      >
                        <input
                          type="text"
                          name="search"
                          value={searchQuery}
                          placeholder={`Search Consult`}
                          onChange={(e) => {
                            setFieldValue('problem', e.target.value)
                            searchData(e, setFieldValue);
                          }}
                          className="w-full border p-2 rounded outline-none"
                        />

                        {leadData?.allProblem?.data?.Problem?.map((res) => {
                          return (
                            <p
                              key={res._id}
                              onClick={() => {
                                selectProblem(res.problem);
                                setFieldValue('problem', res.problem);
                              }}
                              className="text-gray-700 py-1 cursor-pointer"
                            >
                              {res.problem}
                            </p>
                          );
                        })}
                      </div>
                    </div>
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group className="mb-3" controlId="source">
                    <Form.Label>Booking Type</Form.Label>
                    <Form.Select
                      placeholder="Select Booking Type"
                      className="shadow-none focus:!border-theme-dark"
                      name="bookingType"
                      value={formData?.bookingType}
                      onChange={handleData}
                    >
                      <option value="" disabled selected>
                        Select Booking Type
                      </option>
                      <option value="Walk-in">Walk-in</option>
                      <option value="Pre-Booked">Pre-Booked</option>
                      <option value="Online"> Online</option>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group className="mb-3" controlId="source">
                    <Form.Label>Branch</Form.Label>
                    <Form.Select
                      placeholder="Select Branch"
                      className="shadow-none focus:!border-theme-dark"
                      name="branch"
                      value={values.branch}
                      onChange={(e) => handleBranchChange(e, setFieldValue)}
                    >
                      <option value="" disabled selected>
                        Select Branch
                      </option>{' '}
                      {/* Default placeholder option */}
                      {leadData?.allBranch?.data?.Branches?.map((res) => {
                        return (
                          <option key={res._id} value={res.branchName} >
                            {res.branchName}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </div>

                <div className="col-md-4">
                  <Form.Group className="mb-3" controlId="source">
                    <Form.Label>Branch Address</Form.Label>
                    <Form.Control as='textarea' className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px] shadow-none" placeholder='Enter address' name='branchAddress' value={values.branchAddress} onChange={(e) => setFieldValue('branchAddress', e.target.value)} />
                  </Form.Group>
                </div>

                <div className="col-md-4">
                  <Form.Group className="mb-3" controlId="problem">
                    <Form.Label>Doctor </Form.Label>
                    <div className="relative">
                      <input
                        name="doctor"
                        placeholder={values.doctor || 'Select Doctor'}
                        value={values.doctor}
                        readOnly
                        className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                        onClick={() => {
                          setDoctorData1(!doctorData1);
                          setSearchType('doctor');
                        }}
                      />

                      <div
                        className={`${doctorData1
                          ? 'opacity-100 visible'
                          : 'opacity-0 invisible'
                          } absolute w-full border top-full h-[180px] z-10 overflow-auto left-0 rounded p-2 bg-white`}
                      >
                        <input
                          type="text"
                          name="search"
                          value={searchQuery}
                          placeholder={`Search Doctors`}
                          onChange={searchData}
                          className="w-full border p-2 rounded outline-none"
                        />
                        {leadData?.allDoctor?.data?.doctor?.map((res) => (
                          <p
                            key={res._id}
                            onClick={() => {
                              setFieldValue('doctor', res.name);
                              setDoctorData1(false);
                              setSearchQuery('');
                              setSelectedDoctorId(res._id)
                              setSearchDefault({ page: '', search: '' });
                            }}
                            className="text-gray-700 py-1 cursor-pointer"
                          >
                            {res.name}
                          </p>
                        ))}
                      </div>
                    </div>
                  </Form.Group>
                </div>

                <div className="col-md-4">
                  <Form.Group className="mb-3" controlId="problem">
                    <Form.Label>Sub Refence</Form.Label>
                    <Field
                      as={Form.Control}
                      type="text"
                      name="subReference"
                      // onChange={handleData}
                      // value={formData?.subReference}
                      placeholder="Enter Sub Refence"
                      className="shadow-none focus:!border-theme-dark"
                    />
                  </Form.Group>
                </div>

                <div className="col-md-4">
                  <Form.Group className="mb-3" controlId="problem">
                    <Form.Label>Remark</Form.Label>
                    <Field
                      as={Form.Control}
                      type="text"
                      name="remark"
                      placeholder="Enter Remark"
                      className="shadow-none focus:!border-theme-dark"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4">
                  <Form.Group className="mb-3 " controlId="notify">
                    <Form.Label>Notification</Form.Label>
                    <div className="flex gap-3">
                      <Form.Check
                        type="checkbox"
                        label="Whatsapp"
                        name="notification"
                        value="Whatsapp"
                        onChange={handleData}
                        checked={formData?.notification.includes('Whatsapp')}
                        id="whatsapp"
                      />
                      <Form.Check
                        type="checkbox"
                        label="Text"
                        name="notification"
                        value="Text"
                        onChange={handleData}
                        checked={formData?.notification.includes('Text')}
                        id="text"
                      />
                      <Form.Check
                        type="checkbox"
                        label="Email"
                        name="notification"
                        value="email"
                        onChange={handleData}
                        checked={formData?.notification.includes('email')}
                        id="email"
                      />
                    </div>
                  </Form.Group>
                </div>
              </div>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={updateToggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  // onClick={handleAppointment}
                  className="!bg-theme-dark border-0 px-4"
                >
                  Update
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default AppoinmentUpdate;
